import { DocumentObject, deserialize, CaseType } from 'jsonapi-fractal';

/**
 * Deserializes the data from the API response. Accepts a generic type that
 * will be used to infer the type of the data to deserialize.
 * @param data - The data to deserialize.
 * @returns The deserialized data.
 */
export function deserializeData<T>(data: DocumentObject): T {
  const deserializedData = deserialize(data, {
    changeCase: CaseType.camelCase,
  }) as T;

  return deserializedData;
}
